//Componentes generales
import { useEffect, useContext, useRef } from "react";
import ReqList from "../../components/ReqList/ReqList";

//Estilos
import "./Home.css";

//Contexto
import controlGLBContext from "../../context/controlGLB/controlGLBContext";
import controlContext from "../../context/control/controlContext";
import authContext from "../../context/authentication/authContex";
import agregarReqContext from "../../context/agregarReq/agregarReqContext";
import productsContext from "../../context/productos/productsContext";
import proveedoresContext from "../../context/proveedores/proveedoresContext";

import clienteAxios from "../../config/axios";

// Alertas
import Swal from "sweetalert2";
import { useState } from "react";

/* 
    Vista donde se gestiona toda la lógica de listado de comprobantes. Es la vista principal de toda la aplicación.
        Donde props no se encuentra en uso.
*/
function Home(props) {
  //Context auth
  const aContext = useContext(authContext);
  const { usuario, globalSettings } = aContext;

  //Context control comprobantes
  const cContext = useContext(controlContext);
  const {
    listTDoc,
    listTDocBase,
    filtrosRango,
    filtrosEstado,
    modificarFiltrosEstado,
    modificarFiltrosRango,
    iniciarFiltrosIsLoading,
    activeWorkSpace,
    getProductsByNroFor,
    filtrar,
  } = cContext;

  //Contexto general generación de informe
  const gContext = useContext(controlGLBContext);
  const {
    generarInformeReqPDF,
    modificarComprobante,
    getFilesByTDoc,
    enviarReqApi,
  } = gContext;

  //Context productos
  const pContext = useContext(productsContext);
  const { products, actualizarProducts } = pContext;

  //Context Edit Comprobante
  const addContext = useContext(agregarReqContext);
  const { guardarComprobante, editarComprobanteBE } = addContext;

  //Context proveedores
  const provContext = useContext(proveedoresContext);
  const { proveedores, actualizarProveedores } = provContext;

  const [listTDocHome, setListTDocHome] = useState(listTDoc ? listTDoc : []);

  //state de cantidad de requerimientos en estado PENDIENTE
  const [countPendientes, setCountPendientes] = useState(0);

  // Ref para detectar cuándo iniciarFiltros acaba de completarse (transición true → false)
  const prevIniciarFiltrosIsLoading = useRef(false);

  /*
        Disparador que actualiza la lista de productos disponibles al momento de renderizar el componente.
    */
  useEffect(() => {
    const fn = async () => {
      await actualizarProducts();
      await actualizarProveedores();
    };
    fn();
  }, []);

  useEffect(() => {
    // Evitar el cálculo mientras los filtros están siendo reiniciados para evitar parpadeo
    if (iniciarFiltrosIsLoading) return;

    if (listTDoc) {
      // Aplicar filtros de estado
      let listaFiltrada = filtrar(listTDoc, filtrosEstado, usuario);

      // Aplicar filtros de rango (fechas) solo si existen
      if(filtrosRango){
        listaFiltrada = listaFiltrada.filter((r) => {
          const fecAlt = new Date(r.fecAlt);
          const hayFiltroDesdeFecAlt = filtrosRango.fecAlt?.desde;
          const hayFiltroHastaFecAlt = filtrosRango.fecAlt?.hasta;
          
          const dateOfIssue = new Date(r.dateOfIssue);
          const hayFiltroDesdeDateOfIssue = filtrosRango.dateOfIssue?.desde;
          const hayFiltroHastaDateOfIssue = filtrosRango.dateOfIssue?.hasta;

          // Filtro por fecha desde (solo si existe)
          if(hayFiltroDesdeFecAlt && fecAlt < new Date(hayFiltroDesdeFecAlt)) return false;

          // Filtro por fecha hasta (solo si existe)
          if(hayFiltroHastaFecAlt && fecAlt > new Date(hayFiltroHastaFecAlt)) return false;

          // Filtro por fecha de entrega (solo si existe)
          if(hayFiltroDesdeDateOfIssue && dateOfIssue < new Date(hayFiltroDesdeDateOfIssue)) return false;

          // Filtro por fecha hasta (solo si existe)
          if(hayFiltroHastaDateOfIssue && dateOfIssue > new Date(hayFiltroHastaDateOfIssue)) return false;

          return true;
        });
      }

      setListTDocHome(listaFiltrada);
    }

  }, [listTDoc, filtrosEstado, filtrosRango, iniciarFiltrosIsLoading]);

  useEffect(() => {
    // Evitar el cálculo mientras los filtros están siendo reiniciados para evitar parpadeo
    if (iniciarFiltrosIsLoading) {
      prevIniciarFiltrosIsLoading.current = true;
      return;
    }

    if(listTDoc){
      // Solo aplicar filtros y actualizar countPendientes si estamos en el workspace PENDIENTES
      if(activeWorkSpace.pendientes === 1){
        // Aplicar todos los filtros (estado, proveedor, importe, grupos, etc.)
        let listaFiltrada = filtrar(listTDoc, filtrosEstado, usuario);

        // Aplicar filtros de rango (fechas) solo si existen
        if(filtrosRango){
          listaFiltrada = listaFiltrada.filter((r) => {
            const fecAlt = new Date(r.fecAlt);
            const hayFiltroDesdeFecAlt = filtrosRango.fecAlt?.desde;
            const hayFiltroHastaFecAlt = filtrosRango.fecAlt?.hasta;

            const dateOfIssue = new Date(r.dateOfIssue);
            const hayFiltroDesdeDateOfIssue = filtrosRango.dateOfIssue?.desde;
            const hayFiltroHastaDateOfIssue = filtrosRango.dateOfIssue?.hasta;

            // Filtro por fecha desde (solo si existe)
            if(hayFiltroDesdeFecAlt && fecAlt < new Date(hayFiltroDesdeFecAlt)) return false;

            // Filtro por fecha hasta (solo si existe)
            if(hayFiltroHastaFecAlt && fecAlt > new Date(hayFiltroHastaFecAlt)) return false;

            // Filtro por fecha de entrega (solo si existe)
            if(hayFiltroDesdeDateOfIssue && dateOfIssue < new Date(hayFiltroDesdeDateOfIssue)) return false;

            // Filtro por fecha hasta (solo si existe)
            if(hayFiltroHastaDateOfIssue && dateOfIssue > new Date(hayFiltroHastaDateOfIssue)) return false;

            return true;
          });
        }

        const pendientesFiltrados = listaFiltrada.filter((r) => r.state === "PENDIENTE");
        setCountPendientes(pendientesFiltrados.length);
      } else {
        // Si NO estamos en PENDIENTES, solo actualizar cuando iniciarFiltros acaba de completarse.
        // Así los filtros (rango, estado) no modifican el contador al estar en otro workspace.
        if (prevIniciarFiltrosIsLoading.current) {
          const pendientesTotal = listTDoc.filter(r => r.state === 'PENDIENTE');
          setCountPendientes(pendientesTotal.length);
        }
      }
    }

    prevIniciarFiltrosIsLoading.current = false;
  }, [listTDoc, filtrosEstado, filtrosRango, iniciarFiltrosIsLoading, activeWorkSpace]);

  /* 
        Manejador que comprueba los permisos que posee el usuario en sesión para un rol enviado por parametro.
            Donde roles_autorizados es el rol a comprobar.
        Retorna true si esta autorizado, false si no.
    */
  const handleCheckPermisos = (roles_autorizados) => {
    let autoriza = false;
    for (const element of roles_autorizados) {
      if (usuario.userType.some((item) => item.typeName === element)) {
        autoriza = true;
      }
    }
    return autoriza;
  };

  /* 
        Manejador para la modificación rapida de un comprobante. Se utiliza en 3 ocaciones, edición del estado de autorización, notas privadas y notas publicas.
            Donde reqe es el comprobante a actualizar.
                  upd es lo modificado.
    */
  const handleModifyStateReq = async (reqe, upd) => {
    // Al autorizar, si se usan subcuentas y el comprobante no tiene una asignada, se bloquea
    if (
      upd?.state === "AUTORIZADO" &&
      globalSettings?.requiredSubcuenta === true &&
      globalSettings?.codDim &&
      (!reqe?.subCue || reqe.subCue === "")
    ) {
      Swal.fire({
        title: "No se puede autorizar",
        text: "La subcuenta se encuentra sin completar",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    const resp = await modificarComprobante(reqe, usuario, upd);
    return resp;
  };

const handleModifyGruposReq = async (reqe, upd) => {
    const resp = await modificarComprobante(reqe, usuario, upd);
    return resp;
  };

  /* 
        Manejador que recupera todos los items de un comprobante dado por parametro.
            Donde tDocCodFor es el Codfor del comprobante (normalmente REQ).
                  tDocNrofor es el Nrofor del comprobante.
    */
  const handlerVerReqDetails = async (tDocCodFor, tDocNroFor) => {
    return await getProductsByNroFor(tDocCodFor, tDocNroFor);
  };

  /* 
        Manejador que recupera los archivos adjuntados a un comprobante especificado por parametro.
            Donde req es el comprobante de donde recuperar los archivos.
    */
  const handlerRecuperaFiles = async (req) => {
    const files = await getFilesByTDoc(req);
    return files
      ? files.map((f) => {
          return {
            name: f.fileName === undefined ? f.name : f.fileName,
            url: f.url,
          };
        })
      : [];
  };

  /* 
        Manejador encargado de generar un archivo pdf con formato brindado en el back-end. Se descarga automaticamente y se abre en una nueva pestaña.
            Donde doc es el archivo a generar.
                  user es el usuario en sesión que llama a la función.
    */
  const handlerGeneraPDF = async (doc, user) => {
    await generarInformeReqPDF(doc, user);
  };

  /* 
        Función encargada de aplicar y/o inicializar los filtros.
            Donde filtrosProp son los filtros a aplicar.
                  signal no se encuentra actualmente en uso.
        El parametro recibido es un objeto que contiene los filtros de estado y de rango, se aplican cada uno con su respectiva función.
    */
  const apFiltros = async (filtrosProp) => {
    await modificarFiltrosEstado(filtrosProp.filterEstado);
    await modificarFiltrosRango(usuario.cuit, filtrosProp.filterRango);
  };

  /* 
        Función encargada de validar los campos del comprobante a guardar. Valida que este ingresado el titulo, que no existan items sin cantidad y que por lo menos contenga un item con cantidad.
            Donde r es el comprobante a validar.
                  i son los items del comprobante a validar.
        Se llama al momento de guardar.
    */
  const validacionesCampos = (r, i) => {
    let resp = "";
    if (r.title === "") {
      resp = "Falta ingresar titulo de comprobante";
    } else {
      if (i.length === 0) {
        resp = "Ingrese por lo menos un item";
      } else {
        let control = 0;
        for (const element of i) {
          if (element.quantity === 0) {
            control = 1;
          }
        }
        if (control === 1) {
          resp = "Existe un item sin cantidad asignada";
        }
      }
    }
    return resp;
  };

  /* 
        Manejador encargado de guardar un nuevo comprobante. Realiza validaciones y si no la supera no se guarda el comprobante.    
            Donde requeriment es el comprobante a guardar.
                  items son los items del comprobante.
                  files son los archivos adjuntos del comprobante.
    */
  const handleSaveReq = async (requeriment, items, files, conceptos = []) => {
    const msj = validacionesCampos(requeriment, items);
    if (requeriment !== undefined && requeriment !== null) {
      if (msj === "") {
        const resp = await guardarComprobante(
          requeriment,
          items,
          usuario,
          files,
          conceptos
        );
        Swal.fire({
          title: `Se guardó una nueva ${resp.tDocCodForDescrp}`,
          icon: "success",
          text: `El número de la ${resp.tDocCodForDescrp} es: ${resp.tDocNroFor}`,
          showConfirmButton: true,
          allowEnterKey: true,
        });
      } else {
        Swal.fire({
          title: msj,
          icon: "warning",
          showConfirmButton: true,
          allowEnterKey: true,
        });
      }
    }
  };

  /* 
        Manejador que controla el evento ante un click en el boton editar, recuperando los items y archivos adjuntos del comprobante para comenzar la edición.
            Donde req es el comprobante a editar. 
    */
  const handdleEditClick = async (req) => {
    try {
      const items = await getProductsByNroFor(req.tDocCodFor, req.tDocNroFor);
      const allFiles = (await getFilesByTDoc(req)).map((f) => {
        return {
          name: f.fileName === undefined ? f.name : f.fileName,
          url: f.url,
        };
      });

      // Separo los documentos adicionales (marcados con _ADIC_) del archivo principal
      const ADIC_MARKER = "_ADIC_";
      const files = allFiles.filter((f) => !f.name.includes(ADIC_MARKER));
      const aditionalDocs = allFiles
        .filter((f) => f.name.includes(ADIC_MARKER))
        .map((f) => {
          return {
            // Muestro el nombre completo con prefijo, igual que en Detalles
            name: f.name,
            key: f.name,
            url: f.url,
            action: "SAVED",
          };
        });

      return { items, files, aditionalDocs };
    } catch (error) {
      console.log("error");
      return null;
    }
  };

  /* 
        Manejador encargado de guardar los cambios realizados en la edición de un comprobante. Realiza validaciones y si no la supera no se guarda las modificaciones del comprobante.  
            Donde requeriment es el comprobante a guardar.
                  items son los items del comprobante.
                  files son los archivos adjuntos del comprobante.
    */
  const handdleEdit = async (requeriment, items, files, conceptos = [], aditionalDocs) => {
    const msj = validacionesCampos(requeriment, items);

    if (requeriment !== undefined && requeriment !== null) {
      if (msj === "") {
        const resp = await editarComprobanteBE(
          requeriment,
          items,
          files,
          usuario,
          conceptos,
          aditionalDocs
        );
        Swal.fire({
          title: `Se modificó la ${requeriment.tDocCodForDescrp}`,
          icon: "success",
          text: `El número de la ${requeriment.tDocCodForDescrp} modificada es : ${requeriment.tDocNroFor}`,
          showConfirmButton: true,
          allowEnterKey: true,
        });
      } else {
        Swal.fire({
          title: msj,
          icon: "warning",
          showConfirmButton: true,
          allowEnterKey: true,
        });
      }
    }
  };

  /* 
        Manejador encargado de enviar el comprobante a Softland mediante llamada a rutas del webService.
            Donde data es el comprobante a enviar.
    */
  const handdleEnviaApi = async (data) => {
    try {
      await enviarReqApi(data);
      console.log(data);
      Swal.fire({
        title: `Enviado`,
        icon: "success",
        text: `${data.tDocCodForDescrp} ${data.tDocCodFor}-${data.tDocNroFor} enviada correctamente`,
        showConfirmButton: true,
        allowEnterKey: true,
      });
    } catch (err) {
      console.log("Error en enviar a Servidor");
      Swal.fire({
        title: err.message,
        icon: "error",
        showConfirmButton: true,
        allowEnterKey: true,
      });
    }
  };

  return (
    <div className="container-test">
      <ReqList
        proveedores={proveedores}
        listTDoc={listTDocHome}
        modificarEstado={handleModifyStateReq}
        modificarGrupos={handleModifyGruposReq}
        verDetalle={handlerVerReqDetails}
        recuperaFilesDetalle={handlerRecuperaFiles}
        filtros={{ filtrosRango, filtrosEstado }}
        aplicarFiltros={apFiltros}
        productList={products}
        generaPDF={handlerGeneraPDF}
        checkPermisos={handleCheckPermisos}
        guardarComo={handleSaveReq}
        eventoClickEdicion={handdleEditClick}
        editar={handdleEdit}
        sendToAPI={handdleEnviaApi}
        countPendientes={countPendientes}
      />
    </div>
  );
}

export default Home;